import { api } from './api';

export async function uploadSelfie(file: File): Promise<string> {
  const form = new FormData();
  form.append('file', file);
  const { data } = await api.post<{ url: string }>('/api/uploads/selfie', form, { headers: { 'Content-Type': 'multipart/form-data' } });
  return data.url;
}

export async function uploadTaskAudio(blob: Blob): Promise<string> {
  const form = new FormData();
  form.append('file', blob, 'task-audio.webm');
  const { data } = await api.post<{ url: string }>('/api/uploads/task-audio', form, { headers: { 'Content-Type': 'multipart/form-data' } });
  return data.url;
}

export async function uploadBrandingLogo(file: File): Promise<string> {
  const form = new FormData();
  form.append('file', file);
  const { data } = await api.post<{ logoUrl: string }>('/api/branding/logo', form, { headers: { 'Content-Type': 'multipart/form-data' } });
  return data.logoUrl;
}

const baseURL = (import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000').replace(/\/+$/, '');
export const assetUrl = (path: string) => (path.startsWith('http') ? path : `${baseURL}${path}`);
